module.exports = __webpack_public_path__ + "assets/mollie-logo.e970bd71.svg";